import { setAddonsAttributionImageAction as setAddonsAttributionImageOperation } from 'editor/src/store/editorModules/addons/slice';

export default setAddonsAttributionImageOperation;
